// A video starts by itself once half of it is on screen (Sole's review of 19-10-2026). Browsers only let a video
// start on its own when it is muted, so the copy that autoplays is muted and inline: a visitor turns the sound on
// from the player. A click on the poster before that still plays with sound, from the untouched template. Nothing
// moves for a visitor who asked for less motion. Dawn's <deferred-media> loads the player, as on a click.
if (!window.chiamucilVideoAutoplay) {
  window.chiamucilVideoAutoplay = true;

  const start = (media) => {
    if (media.getAttribute('loaded') || typeof media.loadContent !== 'function') return;
    const player = media.querySelector('template')?.content.firstElementChild;
    if (!player) return;
    if (player.nodeName === 'VIDEO') {
      player.setAttribute('muted', '');
      player.setAttribute('playsinline', '');
    } else if (player.nodeName === 'IFRAME') {
      player.setAttribute('src', `${player.getAttribute('src')}&mute=1&playsinline=1`);
    }
    media.loadContent(false);
  };

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          start(entry.target);
        }
      },
      { threshold: 0.5 }
    );
    document.querySelectorAll('deferred-media[data-autoplay-in-view]').forEach((media) => observer.observe(media));
  }
}
